import React, { Component } from "react";
import { MLSUserPreference } from "./react-mlsdata";
import MTWidget from "./index.js";
import { uniqueId, isNull } from "lodash";
import cache from "memory-cache";

export default class UserPreference extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { assets, widgetselections } = { ...this.props };

    var userpref =
      isNull(userpreferStore) == true ? (
        <MLSUserPreference>
          {({ loading, error, data }) => (
            <div className={`markettrends ${loading ? "loading" : ""}`}>
              {loading && (
                <div className="loader msg pos-absolute">Loading...</div>
              )}
              {error && (
                <h2>
                  {console.log(`${error}`)}System error in widgets. Please
                  contact system administrator.
                </h2>
              )}
              {data && (
                <div className="chart-body">
                  <MTWidget
                    widgetselections={widgetselections}
                    assets={data.value}
                  />
                </div>
              )}
            </div>
          )}
        </MLSUserPreference>
      ) : (
        <div className="chart-body">
          <MTWidget
            widgetselections={widgetselections}
            assets={userpreferStore}
          />
        </div>
      );

    return <div> {userpref} </div>;
  }
}



// WEBPACK FOOTER //
// ./src/UserPreference.js